import { useQuery } from "@tanstack/react-query";
import { getProgramBookingListWebByStatus } from "../../../service/programBooking";

const useGetProgramBookingListWebByStatus = (status: string, enabled: boolean, responseQuery?: string) => {
    const query = useQuery({
        queryKey: ['useGetProgramBookingListWebByStatus', status, responseQuery],
        queryFn: () => getProgramBookingListWebByStatus(status, responseQuery),
        enabled: !!enabled && !!status,
        select: res => res.data.data.getProgramBookingListWebByStatus,
    });
    return query;
}

export { useGetProgramBookingListWebByStatus }